import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { FAQS } from "../data/mock";
import Reveal from "./Reveal";

export default function Faq() {
  const [open, setOpen] = useState(1);

  return (
    <section className="section" id="faq">
      <div className="container-x">
        <Reveal>
          <div className="text-center mb-10">
            <div className="font-script" style={{ fontSize: 22, color: "var(--agero-orange)" }}>
              (FAQs)
            </div>
            <h2
              className="font-display mt-3"
              style={{ fontSize: "clamp(40px, 6vw, 92px)", letterSpacing: "-0.05em", lineHeight: 1 }}
            >
              Your Questions, Answered
            </h2>
            <p className="mt-6 text-neutral-600 max-w-xl mx-auto">
              Helping you understand how we work at LinkedIn Lab.
            </p>
          </div>
        </Reveal>

        <div className="max-w-3xl mx-auto flex flex-col gap-3">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={i} delay={i * 70} y={18}>
                <div className="rounded-2xl bg-white overflow-hidden border border-neutral-200/60">
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="w-full flex items-center justify-between px-6 py-5 text-left"
                  >
                    <span className="font-medium text-[17px] text-neutral-900">{f.q}</span>
                    <span
                      className="w-9 h-9 rounded-full flex items-center justify-center transition"
                      style={{
                        background: isOpen ? "var(--agero-orange)" : "#0A0A0A",
                        color: "#fff",
                      }}
                    >
                      {isOpen ? <Minus size={16} /> : <Plus size={16} />}
                    </span>
                  </button>
                  <div
                    className="overflow-hidden transition-all duration-500"
                    style={{ maxHeight: isOpen ? 240 : 0 }}
                  >
                    <p className="px-6 pb-6 text-neutral-600 leading-relaxed">{f.a}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
